var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bag-details-invoice"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Bag Details Invoice")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Hub Zone")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('HubZone')
    },
    attrs: {
      "options": _vm.hubzonelist,
      "selected-option": _vm.hubzoneitem,
      "name": "HubZone",
      "placeholder": "Select Zone",
      "id": "HubZone"
    },
    on: {
      "select": _vm.selectHubZone
    },
    model: {
      value: (_vm.hubzone),
      callback: function($$v) {
        _vm.hubzone = $$v
      },
      expression: "hubzone"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('HubZone')),
      expression: "errors.has('HubZone')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('HubZone')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.hubzoneLoading))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Hub Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('b-input-group', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('HubName')
    },
    attrs: {
      "options": _vm.hubnamelist,
      "name": "HubName",
      "placeholder": "Select Hub Name",
      "track-by": "id",
      "label": "text"
    },
    on: {
      "select": _vm.selectHubName
    },
    model: {
      value: (_vm.hubname),
      callback: function($$v) {
        _vm.hubname = $$v
      },
      expression: "hubname"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('HubName')),
      expression: "errors.has('HubName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('HubName')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.hubnameLoading))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Connection Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-signs'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('ConnectionType')
    },
    attrs: {
      "options": _vm.connectiontypelist,
      "selected-option": _vm.connectiontypeitem,
      "name": "ConnectionType",
      "placeholder": "Select Connection"
    },
    on: {
      "select": _vm.selectConnectionType
    },
    model: {
      value: (_vm.connectiontype),
      callback: function($$v) {
        _vm.connectiontype = $$v
      },
      expression: "connectiontype"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ConnectionType')),
      expression: "errors.has('ConnectionType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ConnectionType')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('label', [_vm._v("Connection Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('ConnectionName')
    },
    attrs: {
      "options": _vm.connectionnamelist,
      "selected-option": _vm.connectionnameitem,
      "name": "ConnectionName",
      "placeholder": "Select Connection Name"
    },
    on: {
      "select": _vm.selectConnectionName
    },
    model: {
      value: (_vm.connectionname),
      callback: function($$v) {
        _vm.connectionname = $$v
      },
      expression: "connectionname"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.connectionnameLoading))]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.connectionnameError))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ConnectionName')),
      expression: "errors.has('ConnectionName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ConnectionName')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#1985ac",
      "font-weight": "bold",
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.actualRoute))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("From Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('FromDate')
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "name": "FromDate"
    },
    model: {
      value: (_vm.fromdate),
      callback: function($$v) {
        _vm.fromdate = $$v
      },
      expression: "fromdate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('FromDate')),
      expression: "errors.has('FromDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('FromDate')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("To Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('ToDate')
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "name": "ToDate"
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ToDate')),
      expression: "errors.has('ToDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ToDate')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "serachbtn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")]), _vm._v(" \n                  ")])])])])], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showList),
      expression: "showList"
    }],
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sr.No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Invoice No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Invoice Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Print Bag List")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bagwise Octroil List")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Generate Manifest")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.InvoiceListArray), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.invoiceno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.invoicedate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticStyle: {
        "color": "#20a8d8",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.getBagDetails(data)
        }
      }
    }, [_vm._v("Print Bag List")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticStyle: {
        "color": "#20a8d8",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.getBagOctroilList(data)
        }
      }
    }, [_vm._v("Bagwise Octroil List")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticStyle: {
        "color": "#20a8d8",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.printClientwiseManifest(data)
        }
      }
    }, [_vm._v("Generate Manifest")])])])
  }), _vm._v(" "), ((_vm.InvoiceListArray && _vm.InvoiceListArray.length == 0) || _vm.InvoiceListArray.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v("No Data found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalRows > 10),
      expression: "totalRows>10"
    }],
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.viewBagListmodel = false
      }
    },
    model: {
      value: (_vm.viewBagListmodel),
      callback: function($$v) {
        _vm.viewBagListmodel = $$v
      },
      expression: "viewBagListmodel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(" Print Invoice")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideBagListmodel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingBag
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingBag = $event
      }
    }
  }), _vm._v(" "), (_vm.BagDetailsArray.length == 0) ? _c('div', [_c('h6', {
    staticStyle: {
      "margin-left": "308px"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), (_vm.BagDetailsArray.length > 0) ? _c('div', {
    staticClass: "modal-bodyfrm",
    attrs: {
      "id": "BagDetailsInvoice"
    }
  }, [_c('table', {
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left",
    staticStyle: {
      "border": "none !important"
    }
  }, [_c('strong', [_vm._v("Print Date :")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.PrintDate)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border": "none !important"
    }
  }, [_c('strong', [_vm._v("Print By :")]), _vm._v(" " + _vm._s(_vm.PrintBy))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "8"
    }
  }, [_c('strong', [_vm._v("XPRESSBEES LINE HAUL BAG DETAILS SHEET")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Date")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Connection")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("GST Reg No")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vehicle No")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("moment")(_vm.InvoiceDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Connection) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.GSTRegNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.VehicleNo))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Sr.No")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Bag No.")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Physical Wt.")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Volumetric Wt.")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Destination")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("No Of Shipments")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Remarks")])])]), _vm._v(" "), _vm._l((_vm.BagDetailsArray), function(bagdata, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bagdata.parentbagno) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bagdata.physicalweight) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bagdata.volumetricweight) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bagdata.bagdestinationhub))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bagdata.bagshipmentscnt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(""))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Total Bags : ")]), _vm._v(_vm._s(_vm.BagDetailsArray.length) + "   \n                ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Total Shipments : ")]), _vm._v(_vm._s(_vm.gettotalshipments()) + "   \n                ")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "height": "80px"
    }
  }, [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_vm._v("\n                  Supervisor Sign\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "vertical-align": "bottom"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                  Driver's sign\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "vertical-align": "bottom"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                  Receiver sign\n                ")])])], 2)]), _c('br'), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Mail ID.:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-envelope'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailId),
      expression: "mailId"
    }],
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "type": "text",
      "name": "mailId",
      "id": "mailId",
      "rows": "2",
      "cols": "50",
      "placeholder": "Enter MailId, Use Comma For Multiple MailId's"
    },
    domProps: {
      "value": (_vm.mailId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailId = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.emailIdErrorMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.emailIdErrorMSG))]) : _vm._e(), _vm._v(" "), (_vm.emailIdValidationMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.emailIdValidationMSG))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.SendMailFunction
    }
  }, [_vm._v("Send Mail")]), _vm._v("  \n            "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFormForMail
    }
  }, [_vm._v("Reset Mail")]), _vm._v("  \n            "), (_vm.printConfig) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.printInvoice
    }
  }, [_vm._v("Print")]) : _vm._e()])], 1)], 1)])])])], 1) : _vm._e()], 1)])]), _vm._v(" "), (_vm.viewBagOctroilListModel == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Bagwise Octroil List"
    },
    model: {
      value: (_vm.viewBagOctroilListModel),
      callback: function($$v) {
        _vm.viewBagOctroilListModel = $$v
      },
      expression: "viewBagOctroilListModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(" Bagwise Octroil List")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideBagOctroilListModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), (_vm.BagOctroilListArray.length == 0) ? _c('div', [_c('h6', {
    staticStyle: {
      "margin-left": "308px"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), (_vm.BagOctroilListArray.data.length > 0) ? _c('div', {
    staticClass: "modal-bodyfrm",
    attrs: {
      "id": "BagOctroilListArray"
    }
  }, [_c('table', {
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left",
    staticStyle: {
      "border": "none !important"
    }
  }, [_c('strong', [_vm._v("Print Date :")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.PrintDate)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border": "none !important"
    }
  }, [_c('strong', [_vm._v("Print By :")]), _vm._v(" " + _vm._s(_vm.PrintBy))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.BagOctroilListArray.city) + " - Shipment Manifest Date and Time " + _vm._s(_vm._f("moment")(_vm.BagOctroilListArray.manifestationDate)))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_c('strong', [_vm._v("GST Reg No. :" + _vm._s(_vm.BagOctroilListArray.GSTRegNo) + " ")])])])])]), _vm._v(" "), _vm._l((_vm.BagOctroilListArray.data), function(BagOctroilListDdata, index) {
    return _c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-left",
      attrs: {
        "colspan": "7"
      }
    }, [_c('strong', [_vm._v("Bag No : " + _vm._s(BagOctroilListDdata.bagnumber))])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("SR NO")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("AWB No.")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Customer Name")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Customer Address")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Pincode")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Goods Description")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Order Value")])])]), _vm._v(" "), _vm._l((BagOctroilListDdata.shipmentManifestInfo), function(data, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.AWBNo))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.customerName))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.customerAddress))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.pincode))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.goodsDescription))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.ordervalue))])])
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-right",
      attrs: {
        "colspan": "6"
      }
    }, [_vm._v("Total Amount")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("TotalMRP")(BagOctroilListDdata.shipmentManifestInfo)))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-right",
      attrs: {
        "colspan": "6"
      }
    }, [_vm._v("Total Shipments")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("ShipmentCount")(BagOctroilListDdata.shipmentManifestInfo)))])])], 2)])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.BagOctroilListArray.data.length > 0) ? _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.printOctroilList
    }
  }, [_vm._v("Print")])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.viewBrooksNdBondModel = false
      }
    },
    model: {
      value: (_vm.viewBrooksNdBondModel),
      callback: function($$v) {
        _vm.viewBrooksNdBondModel = $$v
      },
      expression: "viewBrooksNdBondModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(" Print Invoice")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideBagListmodel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingBag
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingBag = $event
      }
    }
  }), _vm._v(" "), (_vm.BagDetailsArray.length == 0) ? _c('div', [_c('h6', {
    staticStyle: {
      "margin-left": "308px"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), (_vm.BagDetailsArray.length > 0) ? _c('div', {
    staticClass: "modal-bodyfrm",
    attrs: {
      "id": "BagDetailsInvoiceBB"
    }
  }, [_c('table', {
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left",
    staticStyle: {
      "border": "none !important"
    }
  }, [_c('strong', [_vm._v("Print Date :")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.PrintDate)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border": "none !important"
    }
  }, [_c('strong', [_vm._v("Print By :")]), _vm._v(" " + _vm._s(_vm.PrintBy))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("XPRESSBEES LINE HAUL BAG DETAILS SHEET")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('strong', [_vm._v("Date:- ")]), _vm._v(_vm._s(_vm._f("moment")(_vm.InvoiceDate)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "40%"
    }
  }, [_c('strong', [_vm._v("Connection:- ")]), _vm._v(_vm._s(_vm.Connection))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('strong', [_vm._v("GST Reg No:- ")]), _vm._v(_vm._s(_vm.GSTRegNo))])])])]), _vm._v(" "), _vm._l((_vm.BagDetailsArray), function(bd, index) {
    return _c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "10%"
      }
    }, [_c('strong', [_vm._v("Sr. No")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "20%"
      }
    }, [_c('strong', [_vm._v("Bag No.")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "25%"
      }
    }, [_c('strong', [_vm._v("Destination")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "15%"
      }
    }, [_c('strong', [_vm._v("No of Shipments")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "30%"
      }
    }, [_c('strong', [_vm._v("Remarks")])])]), _vm._v(" "), _vm._l((bd), function(bagdata, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "10%"
        }
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "20%"
        }
      }, [_vm._v(_vm._s(bagdata.parentbagno) + " ")]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "25%"
        }
      }, [_vm._v(_vm._s(bagdata.bagdestinationhub))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "15%"
        }
      }, [_vm._v(_vm._s(bagdata.bagshipmentscnt))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "30%"
        }
      }, [_vm._v(_vm._s(bagdata.comment))])])
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-left",
      attrs: {
        "colspan": "5"
      }
    }, [_c('strong', {
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_vm._v("Total Bags = ")]), _vm._v(_vm._s(bd.length) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-left",
      attrs: {
        "colspan": "5"
      }
    }, [_c('strong', {
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_vm._v("Total Shipments = ")]), _vm._v(_vm._s(_vm.gettotalshipments(bd)) + "\n                ")])])], 2)])
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Grand Total")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("Total Bags :")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.allBagsCount))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("Total Shipments :")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.allShipmentsCount))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "height": "80px"
    }
  }, [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_vm._v("Supervisor Name & Sign")]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "vertical-align": "bottom"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Driver Name & Sign")]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "vertical-align": "bottom"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Receiver Name & Sign")])])])]), _c('br'), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Mail ID.:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-envelope'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailId),
      expression: "mailId"
    }],
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "type": "text",
      "name": "mailId",
      "id": "mailId",
      "rows": "2",
      "cols": "50",
      "placeholder": "Enter MailId, Use Comma For Multiple MailId's"
    },
    domProps: {
      "value": (_vm.mailId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailId = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.emailIdErrorMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.emailIdErrorMSG))]) : _vm._e(), _vm._v(" "), (_vm.emailIdValidationMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.emailIdValidationMSG))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.SendMailFunction
    }
  }, [_vm._v("Send Mail")]), _vm._v("  \n            "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFormForMail
    }
  }, [_vm._v("Reset Mail")]), _vm._v("  \n            "), (_vm.printConfig) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.printInvoice
    }
  }, [_vm._v("Print")]) : _vm._e()])], 1)], 1)])])])], 2) : _vm._e()], 1)])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aa514b8","hasScoped":true}!./src/views/components/BagDetailsInvoice/BagDetailsInvoice.html
// module id = 904
// module chunks = 2